import $ from 'jquery';

function initProjectsLanding() {

    const $projectsFiltersForm = $('#projectsFilters');

    // Fetch initial projects with default parameters
    fetchProjects();

    // add event listener for `btnSubmit` click, submit the form
    $('#btnSubmit').on('click', function (event) {
        $projectsFiltersForm.submit();
    });

    // prevent form submission
    $projectsFiltersForm.on('submit', function (event) {
        event.preventDefault();

        // Fetch projects based on form values
        fetchProjects();

    });

    // Filter on change
    $('.js-ProjectsOnChange').on('change', function (event) {

        //check topic change
        if( $(this).attr('id') == 'project_type' ){
            const value = $(this).val();
        }

        // Fetch projects based on form values
        fetchProjects();
    });

    let activePopularRadioButtonId = '';

    // check for js-onPopularChange radio button. get value and set the value for `<select id="project_type" class="js-ProjectsOnChange" name="project_type">`
    $('.js-onPopularChange').on('change', function (event) {
        const value = $(this).val();

        activePopularRadioButtonId = $(this).attr('id');

        $('#project_type').val(value);

        fetchProjects();

    });

    // if already active radio button is clicked, then uncheck the radio button and set the value for `<select id="project_type" class="js-ProjectsOnChange" name="project_type">` to empty
    $('.js-onPopularChange').on('click', function (event) {

        if (activePopularRadioButtonId === $(this).attr('id')) {
            $(this).prop('checked', false);

            $('#project_type').val('all');

            activePopularRadioButtonId = '';

            fetchProjects();
        }

    });

    // Pagination
    $('#projects-pagination-container').on('click', 'a.page-numbers', function (event) {
        event.preventDefault();

        // get the href attribute of the clicked page number. 
        const url = $(this).attr('href');

        // get the value of `paged` from the url path.
        // where url is like `https://city-of-tacoma.lndo.site/wp-admin/admin-ajax.php/page/2/?action=get_projects&project_stage=any&department=all&project_type=all&key`
        let paged = 1;

        const pagedMatch = url.match(/\/page\/(\d+)\//);

        if (pagedMatch) {
            paged = pagedMatch[1];
        }

        fetchProjects(paged);
        //scroll to top of project list
        const element = document.getElementById("projectsFilters");
        element.scrollIntoView();
    });

    // clear filters button
    $('#clear-filters').on('click', function (event) {

        event.preventDefault();
        
        // clear all the filters
        $('#project_stage').val('any');
        $('#department').val('all');
        $('#project_type').val('all');
        $('#title-search').val('');
        
        fetchProjects();
    });


    function fetchProjects(paged = 1) {

        setClearFiltersButtonDisplayStatus();

        updateQuerystring();

        const project_stage = $('#project_stage').val() || '';
        const department = $('#department').val() || '';
        const project_type = $('#project_type').val() || '';
        const key = $('#title-search').val() || '';

        const params = new URLSearchParams({
            action: 'get_projects',
            project_stage: project_stage,
            department: department,
            project_type: project_type,
            key: key,
            paged: paged
        });

        fetch(`${site_data.WP_AJAX}?${params}`)
            .then(response => response.json())
            .then(response => {
                if (!response.success) {
                    throw new Error('Unable to get projects data');
                }

                $('#projects-container').html(response.markup.projects);

                $('#projects-pagination-container').html(response.markup.pagination);

            })
            .catch(error => {
                console.error('Error fetching projects:', error);
                // Additional error handling can be added here
            });
    }

    function hasFiltersApplied() {

        const project_stage = $('#project_stage').val() || '';
        const department = $('#department').val() || '';
        const project_type = $('#project_type').val() || '';
        const key = $('#title-search').val() || '';

        let hasFiltersApplied = false;

        if (project_stage !== '' && project_stage !== 'any') {
            hasFiltersApplied = true;
        }

        if (department !== '' && department !== 'all') {
            hasFiltersApplied = true;
        }

        if (project_type !== '' && project_type !== 'all') {
            hasFiltersApplied = true;
        }

        if (key !== '') {
            hasFiltersApplied = true;
        }

        return hasFiltersApplied;
    }

    function setClearFiltersButtonDisplayStatus() {

        const display = hasFiltersApplied();

        const $clearFiltersContainer = $('.clear-filters-container');

        if ($clearFiltersContainer.length) {

            if (display) {
                $clearFiltersContainer.addClass('display');
            } else {
                $clearFiltersContainer.removeClass('display');
            }

        }
    }

    function updateQuerystring() {

        const display = hasFiltersApplied();

        if (display) {

            const project_stage = $('#project_stage').val() || '';
            const department = $('#department').val() || '';
            const project_type = $('#project_type').val() || '';
            const key = $('#title-search').val() || '';

            const url = new URL(window.location.href);

            url.searchParams.set('project_stage', project_stage);
            url.searchParams.set('department', department);
            url.searchParams.set('project_type', project_type);
            url.searchParams.set('key', key);

            window.history.replaceState({}, '', url);

        } else {
            const url = new URL(window.location.href);

            url.searchParams.delete('project_stage');
            url.searchParams.delete('department');
            url.searchParams.delete('project_type');
            url.searchParams.delete('key');
            
            window.history.replaceState({}, '', url);
        }
    }

}

(($) => {
    initProjectsLanding();
})(jQuery);